import React from 'react';
import { Link } from 'react-router-dom';

// Components
import { Grid, Col } from '../../components/Grid';
import CustomerForm from '../../components/CustomerForm';

// Misc
import { addCustomer } from '../../services/customers';
import { useFlash } from '../../components/FlashMessage';

const AddCustomer = ({ auth }) => {
  const { redirectWithFlash, showFlash } = useFlash();

  const handleSubmit = values => {
    addCustomer(values)
      .then(() => {
        redirectWithFlash('/customers', 'success', 'Customer added!');
      })
      .catch(error => {
        showFlash('error', error);
      });
  };

  return (
    <>
      <Grid>
        <Col>
          <Link to="/customers">&laquo; Back to Customers</Link>
        </Col>
        <Col width="auto">
          <h1>Add Customer</h1>
        </Col>
        <Col></Col>
      </Grid>

      <CustomerForm
        mode="add"
        onSubmit={handleSubmit}
        initialValues={auth.user.role === 'staff' ? { signupStore: auth.user.store } : {}}
      />
    </>
  );
};

export default AddCustomer;
